import * as React from 'react';

import {AccountIcon} from 'shells/icon/svg/account-icon';
import {ContactIcon} from 'shells/icon/svg/contact-icon';
import {LeadIcon} from 'shells/icon/svg/lead-icon';

import type {FormSchemaProperty, EntityTypeFromApi} from './types';

export function filterListItems(listItems: any[], searchValue: string) {
    // For the list view, all items need to be wrapped in rowItem object
    const formattedListItems = listItems.map((item) => ({rowItem: {...item}}));

    if (!searchValue) return formattedListItems;

    // Use the search value as a regex ignoring case
    const pattern = new RegExp(searchValue, 'i');

    // Filter the list to only items with names matching the search term
    return formattedListItems.filter((item) => pattern.test(item.rowItem.label));
}

const mapDisplayTypeToText = (displayType: string) => {
    switch (displayType) {
        case 'textfield':
            return 'Text';
        case 'number':
            return 'Number';
        case 'dropdown':
            return 'Decision';
        case 'checkboxes':
            return 'Multiple choice decision';
        case 'date':
            return 'Date';
        default:
            return 'Text';
    }
};

export const getIcon = (entityType: FormSchemaProperty['entityType']): React.ComponentType<any> => {
    switch (entityType) {
        case 'Accounts':
            return AccountIcon;
        case 'Leads':
            return LeadIcon;
        case 'Contacts':
        default:
            return ContactIcon;
    }
};

export const getTitle = (item: FormSchemaProperty): string => {
    if (item.name === 'name' && item.entityType === 'Accounts') {
        return 'Company name';
    }

    return item.label;
};

export const getSubtitle = (
    entityType: FormSchemaProperty['entityType'],
    isCustomField: boolean,
    displayType: string
) => {
    let entityTypeToShow = 'Person';
    if (entityType === 'Accounts') {
        entityTypeToShow = 'Company';
    }
    if (entityType === 'Leads') {
        entityTypeToShow = 'Lead';
    }
    const displayTypeToShow = isCustomField ? mapDisplayTypeToText(displayType) : undefined;

    if (displayTypeToShow) {
        return `${entityTypeToShow} | ${displayTypeToShow}`;
    }

    return entityTypeToShow;
};

type FieldSortRequiredValues = {
    isDisabled: boolean;
    entityType: EntityTypeFromApi;
    label: string;
};

export function fieldSortFunction(a: FieldSortRequiredValues, b: FieldSortRequiredValues) {
    if (a.isDisabled !== b.isDisabled) {
        return a.isDisabled ? 1 : -1;
    }

    if (a.entityType !== b.entityType) {
        const sortOrder = ['Contacts', 'Accounts', 'Leads'];
        const aEntityTypeIndex = sortOrder.indexOf(a.entityType);
        const bEntityTypeIndex = sortOrder.indexOf(b.entityType);

        return aEntityTypeIndex < bEntityTypeIndex ? -1 : 1;
    }

    return a.label > b.label ? 1 : -1;
}
